import ErrorBoundary from '@/components/ErrorBoundary/ErrorBoundary';
import { NewLayout } from '@/components/NewLayout';
import { AgentSharePage } from '@/pages/agents/pages';
import { PublicAgentInsightsPage } from '@/pages/agents/pages/insights/PublicAgentInsightsPage';
import { Docs } from '@/pages/docs/Docs';
import { MobileHomePage } from '@/pages/mobile/mobile-home-page';
import { UnsupportedPage } from '@/pages/mobile/unsupported';
import { VideoShare } from '@/pages/video-share/VideoShare';
import { AppRoutes } from '@/utils/types';
import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { LandingPage as CampaignLandingPage } from '../pages/campaign';
import { LoginPage } from '../pages/login/Login';
import { RouteType } from './ProtectedRoutes';

export const renderPublicRoutes = () => {
    const routes: RouteType[] = [
        { path: AppRoutes.CampaignLandingPage, tag: 'Campaign', component: <CampaignLandingPage /> },
        {
            path: AppRoutes.AgentShare,
            tag: 'Agent Share',
            component: <AgentSharePage />,
            layout: (props: any) => <NewLayout {...props} />,
            title: 'D-ID Agent',
        },
        {
            path: AppRoutes.InsightsShare,
            tag: 'Insights Share',
            component: <PublicAgentInsightsPage />,
            title: 'Agent Insights - D-ID',
        },
        { path: AppRoutes.Share, tag: 'Share', component: <VideoShare /> },
        { path: AppRoutes.Login, tag: 'Login', component: <LoginPage /> },
        { path: AppRoutes.Unsupported, tag: 'Unsupported', component: <UnsupportedPage /> },
        { path: AppRoutes.MobileHomepage, tag: 'Mobile Home Page', component: <MobileHomePage /> },
        { path: AppRoutes.Docs, tag: 'Docs', component: <Docs /> },
    ];

    return routes.map(route => {
        const Layout = route.layout || React.Fragment;

        return (
            <Route
                key={route.path}
                path={route.path}
                element={
                    <Layout>
                        <ErrorBoundary fallback={<Navigate to="/" />} beforeCapture={scope => scope.setTag('component', route.tag)}>
                            {route.component}
                        </ErrorBoundary>
                    </Layout>
                }
            />
        );
    });
};
